import { MsalProvider } from '@azure/msal-react';
import { authenticationClientProvider, EnvConfig } from '@config';
import { jssPreset, StylesProvider } from '@material-ui/core/styles';
import AuthenticationProvider from 'components/AuthenticationProvider';
import { WindowContextProvider } from 'components/WindowContext/WindowContext';
import { create } from 'jss';
import React, { useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Store } from 'redux';

import Root from './components/Root';
import Routes from './routes';
interface Props {
  store: Store;
}

const jss = create({
  ...jssPreset(),
  // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
  insertionPoint: document.getElementById('jss-insertion-point') ?? undefined,
});

const App: React.FunctionComponent<Props> = ({ store }) => {
  useEffect(() => {
    const siteId = EnvConfig.hotjar_site_id;
    const hotjarVersion = 6;
    try {
      if (siteId && siteId.length > 0) {
        hotjar.initialize({ id: Number(siteId), sv: hotjarVersion });
      }
    } catch (e) {
      console.error('Error initializing Hotjar', e);
    }
  }, []);

  return (
    <StylesProvider jss={jss}>
      <Provider store={store}>
        <WindowContextProvider>
          <BrowserRouter>
            <MsalProvider instance={authenticationClientProvider}>
              <AuthenticationProvider>
                <Root>
                  <Routes />
                </Root>
              </AuthenticationProvider>
            </MsalProvider>
          </BrowserRouter>
        </WindowContextProvider>
      </Provider>
    </StylesProvider>
  );
};

export default App;
